import styled, { css } from 'styled-components';
import NavLink from 'gatsby-theme-menus/src/components/nav/list-nav/nav-link';
import activeClassName from 'gatsby-theme-menus/src/components/nav/activeClassName';

export default styled(NavLink)`
  ${({ theme }) => css`
    color: ${theme.fontColor};
    font-weight: ${theme.accentFontWeight || 600};

    &.${activeClassName},
    &:hover {
      color: ${theme.primaryColor};
    }
  `}
`;
